// Extra data to be stored at end of .phi file ------------------------------------------------

type Version = 'v0.1' | 'v0.2';

export class ExtraData {
    version: Version;
    data: Record<string, any>;

    constructor(version: Version) {
        this.version = version;
        this.data = {};
    }

    add_data_element(extra_data_element: Element) {
        this.data[extra_data_element.type] = extra_data_element.fields;
    }
}

export class Element {
    type: string;
    fields: Record<string, any>;

    constructor(type: string) {
        this.type = type;
        this.fields = {};
    }

    add_field(key: string, value: any) {
        this.fields[key] = value;
        return this;
    }
}
